import { useMemo } from 'react'
import { ActionCardModel, SectionData, sectionTypes } from '@playbooks/action-cards-utils/src'

/**
 * This hook is used to get the sections that are in the same scope as the given section
 * @param actionCardsModel - the ActionCardModel instance
 * @param sectionData - the given section
 * @returns SectionData[] the sections that are in the same scope as the given section
 */
export default function useScopeSections(actionCardsModel: ActionCardModel, sectionData: SectionData) {
  return useMemo((): SectionData[] => {
    const searchService = actionCardsModel.getSearchService()
    const secTypes = Object.values(sectionTypes)
    return (
      searchService
        .filter(x => {
          const node = x.data as SectionData
          return node.idOfSep === sectionData.idOfSep && secTypes.some(type => type === node.type)
        })
        .map(field => field.data) || []
    )
  }, [sectionData, actionCardsModel])
}
